import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { PageNode } from '../../common/services';


@Component({
  selector: 'p8-bdc-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  @Input() page: PageNode;
  @Input() opened: boolean;
  @Output() openedChange = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  toggleSidenav() {
    this.opened = !this.opened;
    this.openedChange.emit(this.opened);
  }
}
